import { GRadio } from 'components/basic-blocks/g-radio'
import { classNames } from 'utils'
import { truncateString } from '../../../../../../../../utils/text'
import { AiProtectionProps } from './types'

const buildContainerClassName = (aiProtection: string) => {
	return classNames(
		'py-5 flex flex-col gap-2',
		aiProtection === 'enabled' ? '' : ''
	)
}

export const AiProtection = ({
	inheritName,
	level,
	aiProtection,
	setAiProtection
}: AiProtectionProps) => {
	const truncatedInheritName = truncateString(inheritName || '', 20)

	return (
		<div className={buildContainerClassName(aiProtection)}>
			<GRadio
				name="disabled"
				label="Disable AI protection (not recommended)"
				checked={aiProtection === 'disabled'}
				value="disabled"
				onChange={(e) => setAiProtection(e.target.value)}
				labelClass="text-t-default font-normal"
				helpToolTip="Disable automated protection. You can still create and use custom rules."
			/>
			{level !== 'website' && (
				<>
					<GRadio
						name="inherit"
						label={`Inherit protection settings from ${truncatedInheritName}`}
						checked={aiProtection === 'inherit'}
						value="inherit"
						onChange={(e) => setAiProtection(e.target.value)}
						labelClass="text-t-default font-normal"
						helpToolTip={`Protection settings defined on ${truncatedInheritName} will be applied here as well.`}
					/>
				</>
			)}
			{level === 'website' ? (
				<GRadio
					name="enabled"
					label="Enable AI protection"
					checked={aiProtection === 'enabled'}
					value="enabled"
					onChange={(e) => setAiProtection(e.target.value)}
					labelClass="text-t-default font-normal"
					helpToolTip="This website will have dedicated protection settings."
				/>
			) : (
				<GRadio
					name="enabled"
					label={`${
						level === 'ad-account' ? 'Account-specific' : 'Campaign-specific'
					} protection settings`}
					checked={aiProtection === 'enabled'}
					value="enabled"
					onChange={(e) => setAiProtection(e.target.value)}
					labelClass="text-t-default font-normal"
					helpToolTip={`This ${
						level === 'ad-account' ? 'account' : 'campaign'
					} will have dedicated protection settings and will not be overridden by the ${inheritName} protection settings.`}
				/>
			)}
		</div>
	)
}
